import React from "react";
import AdminRecoleccionesView from "../../views/adminView/adminRecolecciones/adminRecolecciones";

export default function AdminRecolecciones() {
  return <AdminRecoleccionesView />;
}
